
import React, { createContext, useContext } from 'react';
import { AuthUser } from '../types/AuthTypes';

// Define the context type
export interface AuthContextType {
  user: AuthUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (email: string, password: string, name?: string) => Promise<void>;
  signOut: () => Promise<void>;
  hasRole: (role: string) => boolean;
}

// Create context with default values
const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: false,
  isAuthenticated: false,
  signIn: async () => {},
  signUp: async () => {},
  signOut: async () => {},
  hasRole: () => false
});

// Custom hook for using the auth context
export const useAuthContext = () => useContext(AuthContext);

export default AuthContext;
